<template>
  <router-link
      class="mx-1 flex items-center px-6 py-2 mt-4 duration-200"
      :class="[$route.name === item.route ?
      'bg-gray-600 bg-opacity-25 text-gray-100 border-l-4 border-gray-100' :
      'border-l border-gray-500 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100']"
      :to="{name: item.route}"
  >
    <component :is="item.icon" class="flex-shrink-0 w-5 h-5"/>

    <span class="ml-4 mr-2">{{ item.title }}</span>

    <span v-if="item.badge" class="inline-block leading-tight px-1 font-medium bg-red-700 text-xs text-white rounded">
      {{ item.badge }}
    </span>
  </router-link>
</template>
<script>
export default {
  name: 'SidebarLink',
  props: {
    item: Object
  }
}
</script>